// extracted by mini-css-extract-plugin
export default {"validationErrorTooltip":"sidebar-text-input-module__validationErrorTooltip--rRFCi"};